import React from 'react';

import FilterTabsComponent from './filter-tabs.component.jsx';

const FilterTabs = (props) => {
    return <FilterTabsComponent {...props} />;
};

export default FilterTabs;
